// lib
import { connect } from 'react-redux';
import get from 'lodash/get';

// component
import EcomPolicy from './EcomPolicy';

// redux
import {
  getCashOnDeliveryDetails,
  getDeliveryDetails,
  getReturnExchangeDetails,
  getProductId,
  getAllInStockSKUs,
  getDeliveryOrShippingTextV1,
  isFetching,
} from 'shared/store/details/selectors';
import { fetchDeliveryorShippedDate } from 'shared/store/details/services';
import { getRemoteConfig } from 'shared/store/remoteConfigs/selectors';

const mapStateToProps = (state: any) => {
  return {
    cashOnDelivery: getCashOnDeliveryDetails(state),
    returnAndExchange: getReturnExchangeDetails(state),
    deliveryDetails: getDeliveryDetails(state),
    productId: getProductId(state),
    isFetching: isFetching(state),
    inStockSKUs: getAllInStockSKUs(state),
    deliveryOrShippingText: getDeliveryOrShippingTextV1(state),
    isEddEnabled: get(getRemoteConfig(state, 'eddEnabled'), 'desktop', true),
  };
};

const mapDispatchToProps = {
  fetchDeliveryorShippedDate,
};

export default connect(mapStateToProps, mapDispatchToProps)(EcomPolicy);
